import React from 'react';
import { 
  Card, 
  Group, 
  Button, 
  Title, 
  Text, 
  Divider, 
  SimpleGrid, 
  Badge, 
  Select, 
  Box,
  Menu,
  ActionIcon 
} from '@mantine/core';
import { 
  IconRefresh, 
  IconTrash, 
  IconDatabaseOff, 
  IconDotsVertical 
} from '@tabler/icons-react';
import { useCacheControl } from '../../hooks/use-cache-control';
import { EntityType } from '../../types/cache-types';
import { useState } from 'react';

export function CacheControlPanel() {
  const { 
    invalidateEntityCache, 
    refreshEntityCache, 
    resetEntireCache,
    isAdmin 
  } = useCacheControl();
  
  const [selectedEntity, setSelectedEntity] = useState<EntityType>('products');
  
  if (!isAdmin) {
    return (
      <Card withBorder shadow="xs" p="lg">
        <Text color="dimmed">
          Accesso riservato agli amministratori.
        </Text>
      </Card>
    );
  }
  
  const entityOptions = [
    { value: 'products', label: 'Prodotti' },
    { value: 'users', label: 'Utenti' },
    { value: 'settings', label: 'Impostazioni' },
    { value: 'requests', label: 'Richieste' },
    { value: 'request', label: 'Dettaglio Richieste' },
  ];
  
  const handleInvalidate = () => {
    invalidateEntityCache(selectedEntity);
  };
  
  const handleRefresh = () => {
    refreshEntityCache(selectedEntity);
  };
  
  const handleRefreshWithOptions = (options: { type: 'active' | 'inactive' | 'all', exact: boolean }) => {
    refreshEntityCache(selectedEntity, {
      refetchType: options.type,
      exact: options.exact,
    });
  };
  
  return (
    <Card withBorder shadow="sm" p="md">
      <Group justify="space-between" mb="md">
        <Title order={4}>Controllo Cache</Title>
        <Badge color="indigo">Admin</Badge>
      </Group>
      
      <Text size="sm" color="dimmed" mb="lg">
        Gestisci la cache dell'applicazione. Puoi invalidare o ricaricare i dati per diverse entità.
      </Text>
      
      <Group mb="md">
        <Select
          label="Seleziona entità"
          description="Scegli il tipo di dati da gestire"
          data={entityOptions}
          value={selectedEntity}
          onChange={(value) => setSelectedEntity(value as EntityType)}
          style={{ flex: 1 }}
        />
        
        <Box pt={25}>
          <Menu width={200} position="bottom-end" shadow="md">
            <Menu.Target>
              <ActionIcon variant="subtle" size="lg">
                <IconDotsVertical size={16} />
              </ActionIcon>
            </Menu.Target>
            
            <Menu.Dropdown>
              <Menu.Label>Opzioni avanzate</Menu.Label>
              
              <Menu.Item
                onClick={() => handleRefreshWithOptions({ type: 'active', exact: false })}
              >
                Ricarica solo query attive
              </Menu.Item>
              
              <Menu.Item
                onClick={() => handleRefreshWithOptions({ type: 'inactive', exact: false })}
              >
                Ricarica solo query inattive
              </Menu.Item>
              
              <Menu.Item
                onClick={() => handleRefreshWithOptions({ type: 'all', exact: true })}
              >
                Ricarica corrispondenze esatte
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Box>
      </Group>
      
      <SimpleGrid cols={2} mb="lg">
        <Button 
          variant="outline"
          onClick={handleInvalidate}
          color="orange"
        >
          Invalida
        </Button>
        
        <Button 
          onClick={handleRefresh}
          color="green"
        >
          Ricarica
        </Button>
      </SimpleGrid>
      
      <Divider my="md" label="Reset Globale" labelPosition="center" />
      
      <Button 
        onClick={resetEntireCache}
        color="red"
        variant="light"
        fullWidth
      >
        Reset Completo Cache
      </Button>
      
      <Text size="xs" color="dimmed" mt="xs">
        Attenzione: il reset completo rimuoverà tutti i dati in cache e costringerà l'applicazione a ricaricarli quando necessario.
      </Text>
    </Card>
  );
}